import { useState, useEffect } from "react";
import axios from "axios";
import { Alert, Modal, Col, Row, Form, Button } from "react-bootstrap";

const UpdatePaidModal = (props) => {
  var moment = require("moment");
  const today = moment().format("YYYY-MM-DD");
  const displayDateFormat = "DD/MM/YYYY";

  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");

  const [isLoading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [datePaid, setDatePaid] = useState("");

  const exam = props.exam;
  const token = JSON.parse(ls.get("jwt"));

  useEffect(() => {
    if (exam) {
      setDatePaid(exam.datePaid);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function isIncomplete() {
    return !datePaid || datePaid === "";
  }

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  function GetError(error) {
    return error.response
      ? "ERROR: " + error.response.data?.error?.message
      : "ERROR: " + error.mesage;
  }

  const handleSubmit = async (e) => {
    setLoading(true);
    setErrorMessage(null);
    e.preventDefault();

    let isError = false;
    /* consultar el user con los datos de examenes, 
         buscar el examen a procesar y lo actualiza
      */
    const u = await axios
      .get(`${API_URL}/users/${exam.userId}`, headerRequest)
      .catch((error) => {
        isError = true;
        setErrorMessage(GetError(error));
      });

    if (!isError) {
      let reqUser = u.data;
      let userExams = reqUser.exams;

      const examToUpdateIdx = userExams.findIndex((e) => {
        if (e.grade.id == exam.gradeId) {
          return true;
        }
        return false;
      });

      if (examToUpdateIdx >= 0) {
        userExams[examToUpdateIdx].datePaid = datePaid;
      }
      reqUser.exams = userExams;

      await axios
        .put(`${API_URL}/users/${exam.userId}`, reqUser, headerRequest)
        .then(() => {
          setLoading(false);
          props.onHide(true);
        })
        .catch((error) => {
          console.log("Error with put users:", error.response);
          setErrorMessage(GetError(error));
        });
    }
    setLoading(false);
  };

  return (
    <Modal
      {...props}
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Editar Exámen
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="show-grid">
        <Form onSubmit={(e) => handleSubmit(e)}>
          <Row className="mb-1">
            <h5>Datos del Alumno</h5>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="formDocNumber">
              <Form.Label>Núm. Documento</Form.Label>
              <Form.Control readOnly value={exam.docNumber} />
            </Form.Group>
            <Form.Group as={Col} controlId="formLastname">
              <Form.Label>Nombre</Form.Label>
              <Form.Control readOnly value={exam.fullname} />
            </Form.Group>
          </Row>
          <hr />
          <Row className="mb-1">
            <h5>Datos del Exámen</h5>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="formGrade">
              <Form.Label>Graduación aprobada</Form.Label>
              <Form.Control readOnly value={exam.grade} />
            </Form.Group>

            <Form.Group as={Col} controlId="formBirthDate">
              <Form.Label>Fecha de Examen</Form.Label>
              <Form.Control
                readOnly
                value={moment(exam.date).format(displayDateFormat)}
              />
            </Form.Group>
          </Row>

          <Row className="mb-1">
            <h6>Datos del Pago</h6>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="formBirthDate">
              <Form.Label>Fecha Pago</Form.Label>
              <Form.Control
                type="date"
                name="datePaid"
                max={today}
                value={datePaid}
                onChange={(e) => setDatePaid(e.target.value)}
              />
            </Form.Group>
          </Row>
          <Button
            variant="primary"
            type="submit"
            disabled={isLoading || isIncomplete()}
          >
            {isLoading ? "Procesando…" : "GRABAR"}
          </Button>
          {errorMessage ? (
            <Alert className="mt-3" variant="danger">
              {errorMessage}
            </Alert>
          ) : (
            <></>
          )}
        </Form>
      </Modal.Body>
    </Modal>
  );
};
export default UpdatePaidModal;
